// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accordion/style/index.less
// module id = 154
// module chunks = 0